import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { telegramBotKeys } from '../telegramBot.keys';
import { getTelegramBotConfig } from '../telegramBot.service';
export const useTelegramBotConfig = (subdomain = getSubdomain()) => {
    return useQuery({
        queryKey: telegramBotKeys.config(subdomain),
        queryFn: () => getTelegramBotConfig(subdomain),
        enabled: !!subdomain && subdomain !== 'root',
    });
};
